import { LanguageOutlined, NumbersOutlined } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { GenericOrganization } from '@app/src/types/organizations'
import ReactCountryFlag from 'react-country-flag'
import useLocalisedCountryName from '@app/src/hooks/useLocalisedCountryName'

interface OrganizationDetailsGlanceCardProps {
  organization: GenericOrganization
}

export const OrganizationDetailsGlanceCard: React.FC<OrganizationDetailsGlanceCardProps> = ({ organization }) => {
  const { getLocalisedCountryName } = useLocalisedCountryName()

  return (
    <Stack gap={0.5}>
      {organization.country?.name && (
        <Box display="flex" alignItems="center" gap={1}>
          <Stack width="20px" height="20px" alignItems="center" justifyContent="center" flexShrink="0">
            <ReactCountryFlag countryCode={organization.country.countryCode} svg style={{ fontSize: '1.3em' }} />
          </Stack>
          <Typography variant="caption" color="text.secondary">
            {getLocalisedCountryName(organization.country.countryCode)}
          </Typography>
        </Box>
      )}
      {organization.websiteAddress && (
        <Box display="flex" alignItems="center" gap={1}>
          <LanguageOutlined color="action" fontSize="small" />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              wordBreak: 'break-word',
            }}
          >
            {organization.websiteAddress}
          </Typography>
        </Box>
      )}
      {(organization.vatNumber || organization.registrationNumber) && (
        <Box display="flex" alignItems="center" gap={1}>
          <NumbersOutlined color="action" fontSize="small" />
          <Typography variant="caption" color="text.secondary">
            {[organization.vatNumber, organization.registrationNumber].filter(Boolean).join(' / ')}
          </Typography>
        </Box>
      )}
    </Stack>
  )
}
